import { render } from "./DialogFullSize.vue?vue&type=template&id=3aae09e8"
import script from "./DialogFullSize.vue?vue&type=script&lang=js"
export * from "./DialogFullSize.vue?vue&type=script&lang=js"

import "./DialogFullSize.vue?vue&type=style&index=0&id=3aae09e8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__